export const SPEAKER_ZONE_PAGE_ROUTE = 'speakers_zone';

export const isSpeakersZoneRoute = () =>
  window.location.pathname.includes(SPEAKER_ZONE_PAGE_ROUTE);
